module.exports = __webpack_public_path__ + "static/media/default-dashboard.9cc27f59.png";